import * as actionTypes from "../actions/actionTypes";
const reload = (state = { reload: true }, action) => {
  switch (action.type) {
    case actionTypes.RELOAD:
      return { ...state, reload: !state.reload };
    default:
      return state;
  }
};

export default reload;
